import React from 'react';
import { useLang } from '../context/LanguageContext';
import { useContent } from '../context/ContentContext';
import { resolveImg } from '../api';
import { socials } from '../data/mock';
import { Shield, Feather } from 'lucide-react';

// category: 'acier' | 'titane'
const ProtheseSection = ({ category }) => {
  const { t, lang } = useLang();
  const { content } = useContent();

  const all = content?.protheses || [];
  const items = all.filter((p) => p.category === category);

  const isTitane = category === 'titane';
  const tr = isTitane ? t.protheseTitane : t.protheseAcier;
  const sectionId = isTitane ? 'prothese-titane' : 'prothese-acier';
  const Icon = isTitane ? Feather : Shield;

  // Visual variants: acier = light marble (bg-white), titane = warm cream (bg-[#FAF8F4])
  const bgClass = isTitane ? 'bg-[#FAF8F4]' : 'bg-white';

  const openBooking = () => window.open(socials.instagram, '_blank', 'noopener,noreferrer');

  return (
    <section id={sectionId} className={`section-pad ${bgClass} relative overflow-hidden border-t border-[#E8E2D5]`}>
      <div className="container-tight relative">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <span className="eyebrow inline-flex items-center gap-2">
            <Icon size={12} className="text-[#957340]" />
            {tr.eyebrow}
          </span>
          <h2 className="h-display mt-6" style={{ fontSize: 'clamp(40px, 5vw, 60px)' }}>
            {tr.title}
          </h2>
          <p className="text-[15px] text-[#3A3A3A] leading-[1.8] mt-6">{tr.subtitle}</p>
        </div>

        {items.length === 0 ? (
          <div className="text-center py-20 border border-dashed border-[#1A1A1A]/15 bg-white max-w-2xl mx-auto">
            <Icon size={28} className="mx-auto text-[#957340] mb-4" />
            <p className="serif text-[20px] text-[#1A1A1A]">{tr.empty}</p>
            <button onClick={openBooking} className="link-underline mt-6 inline-block">
              {lang === 'fr' ? 'Nous contacter' : 'Contact us'}
            </button>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {items.map((p, i) => (
                <div key={p.id} className="bg-white border border-[#E8E2D5] overflow-hidden image-hover group">
                  <div className="aspect-square bg-[#FAF8F4]">
                    {p.img && <img src={resolveImg(p.img)} alt={p.nameFr} className="w-full h-full object-cover" />}
                  </div>
                  <div className="p-4">
                    <div className="flex items-baseline justify-between">
                      <h3 className="serif text-[17px] text-[#1A1A1A]">
                        {lang === 'fr' ? p.nameFr : p.nameEn || p.nameFr || `Modèle ${i + 1}`}
                      </h3>
                      {p.priceFrom && <span className="display text-[16px] text-[#957340]">{p.priceFrom}</span>}
                    </div>
                    <div className="text-[10px] tracking-[0.28em] uppercase text-[#957340] mt-1">
                      {isTitane ? 'Titane G23' : 'Acier 316L'}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-14 text-center">
              <button onClick={openBooking} className="btn-primary">
                {lang === 'fr' ? 'Nous contacter' : 'Contact us'}
              </button>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default ProtheseSection;
